import Vue from "vue";
import VueRouter from "vue-router";

import Store from "@/store/index";

import Positions from "@/pages/positions";

import Documents from "@/pages/documents";
import DocumentForm from "@/pages/documents/form";
import MedicalAnalyses from "@/pages/medical-analyses";
import MedicalAnalysesForm from "@/pages/medical-analyses/form";

import ReferenceClients from "@/pages/reference-clients";
import ReferenceUniform from "@/pages/references/uniform";
import ReferenceUniformItems from "@/pages/references/uniform-items";
import ReferenceVacationTypes from "@/pages/references/vacation-types";
import ReferenceIikoAccess from "@/pages/references/iiko-access";

import ReferenceLoadTypes from "@/pages/references/load-types";

import PositionsProduction from "@/pages/positions/production";

import PrintPersonalAccount from "@/pages/personal-employee/finance/print-personal-account";
import PrintCalculationSheet from "@/pages/calculation-sheets/calculation-sheet/additions/print-calculation-sheet";

import Functions from "@/pages/functions";
import Function from "@/pages/functions/function";
import FunctionInformation from "@/pages/functions/function/information";
import FunctionIndicators from "@/pages/functions/function/indicators";
import FunctionDebugging from "@/pages/functions/function/debugging";

import AddressesCorrection from "@/pages/calculations/addresses/index";

import TablesSettingsList from "@/pages/settings/tables-settings-list";
import TableSettings from "@/pages/settings/table-settings";

import AutoCreationCalcSheets from "@/pages/settings/auto-creation-calc-sheets/";


import { userPermissionsList } from "@/constants/userPermissions";

import calculationsRoutes from "./modules/calculations";
import olapRoutes from "./modules/olap";
import employeesRoutes from "./modules/employees";
import personalEmployeeRoutes from "./modules/personal-employee";
import chartsRoutes from "./modules/charts";
import reportsRoutes from "./modules/reports";
import profilesRoutes from "./modules/profiles";
import errorsRoutes from "./modules/errors";
import uikitRoutes from "./modules/uikit";

Vue.use(VueRouter);

export default new VueRouter({
    mode: "hash",
    routes: [
        ...calculationsRoutes,
        ...olapRoutes,
        ...employeesRoutes,
        ...personalEmployeeRoutes,
        ...chartsRoutes,
        ...reportsRoutes,
        ...profilesRoutes,

        {
            path: "/personal-account-print",
            name: "personal-account-print",
            component: PrintPersonalAccount,
            meta: {
                print: true,
            },
            props: true,
        },

        {
            path: "/calculation-sheet-print",
            name: "calculation-sheet-print",
            component: PrintCalculationSheet,
            // meta: {
            //     print: true,
            // },
            props: true,
        },

        {
            path: "/positions",
            component: Positions,
            name: "positions-main",
            children: [
                {
                    name: "positions",
                    path: "/positions/:code",
                    component: PositionsProduction,
                    meta: {
                        title: "Должности",
                    },
                },
            ],
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    next();
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/position-form/:positionCode",
            name: "position-form",
            component: () => import("../pages/positions/position-form/index"),
            props: (route) => ({
                positionCode: route.params.positionCode,
            }),
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    next();
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-clients",
            component: ReferenceClients,
            children: [
                {
                    name: "reference-clients",
                    path: "/",
                    component: PositionsProduction,
                    meta: {
                        title: "Клиенты",
                    },
                },
            ],
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length === 0 && Store.state.userId.length === 0) {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }

                if (Store.state.isAccessIikoCustomersControl) {
                    next();
                } else {
                    next({ name: "error-403" });
                }
            },
        },
        {
            path: "/reference-uniform",
            component: ReferenceUniform,
            meta: {
                title: "Структура каталога ТМЦ",
            },
            name: "reference-uniform",
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = [userPermissionsList.referenceBooks.uniform.control];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-uniform-items",
            component: ReferenceUniformItems,
            meta: {
                title: "Каталог товарно-материальных ценностей",
            },
            name: "reference-uniform-items",
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = [userPermissionsList.referenceBooks.uniformItems.control];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-vacation-types",
            component: ReferenceVacationTypes,
            meta: {
                title: "Типы отпусков",
            },
            name: "reference-vacation-types",
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["updateVacationType"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-load-types",
            component: ReferenceLoadTypes,
            meta: {
                title: "Типы нагрузок",
            },
            name: "reference-load-types",
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["typeLoadControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-iiko",
            component: ReferenceIikoAccess,
            meta: {
                title: "Настройки доступов к IIKO",
            },
            name: "reference-iiko",
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["iikoAccessSettingsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },

        {
            path: "/documents",
            name: "documents-list",
            component: Documents,
            meta: {
                title: "Документы",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["typeDocumentsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/documents/edit/:id",
            name: "edit-document",
            component: DocumentForm,
            meta: {
                title: "Редактировать документ",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["typeDocumentsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/documents/create",
            name: "create-document",
            component: DocumentForm,
            meta: {
                title: "Новый документ",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["typeDocumentsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/medical-analyses",
            name: "medical-analyses-list",
            component: MedicalAnalyses,
            meta: {
                title: "Медицинские анализы",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = [userPermissionsList.referenceBooks.medicalAnalyses.control];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/medical-analyses/create",
            name: "create-medical-analyse",
            component: MedicalAnalysesForm,
            meta: {
                title: "Новый анализ",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["medicalAnalysisControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/medical-analyses/edit/:id",
            name: "edit-medical-analyse",
            component: MedicalAnalysesForm,
            meta: {
                title: "Редактировать анализ",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["medicalAnalysisControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/tables-settings",
            name: "tables-settings",
            component: TablesSettingsList,
            meta: {
                title: "Настройки таблиц",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["columnSettingsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "auto-creation-calc-sheets" })
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/tables-settings/create",
            name: "create-table-settings",
            component: TableSettings,
            meta: {
                title: "Настройка таблицы",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["columnSettingsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "auto-creation-calc-sheets" })
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/tables-settings/edit/:id",
            name: "edit-table-settings",
            component: TableSettings,
            meta: {
                title: "Настройка таблицы",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["columnSettingsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "auto-creation-calc-sheets" })
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },

        {
            path: "/auto-creation-calc-sheets",
            name: "auto-creation-calc-sheets",
            component: AutoCreationCalcSheets,
            meta: {
                title: "Автоматическое создание ведомостей",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["automaticCalculationSheetControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            window.location.replace("/index.php?r=total-settings%2Findex");
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },

        {
            path: "/addresses-correction",
            name: "addresses-correction",
            component: AddressesCorrection,
            meta: {
                title: "Корректировка адресов",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["viewBadAddress", "updateBadAddress"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-private-transactions-reasons",
            name: "reference-private-transactions-reasons",
            component: () => import("../pages/references/reasons-for-private-transactions"),
            meta: {
                title: "Причины для операций с личным счётом",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = [userPermissionsList.referenceBooks.reasonsPersonalAccountTransactions.control];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/functions",
            name: "functions",
            component: Functions,
            meta: {
                title: "Функции",
            },

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["functionsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/function",
            name: "function",
            component: Function,
            meta: {
                title: "Новая функция",
            },
            children: [
                {
                    path: "/function/information",
                    name: "function-information",
                    component: FunctionInformation,
                },
                {
                    path: "/function/indicators",
                    name: "function-indicators",
                    component: FunctionIndicators,
                },
                {
                    path: "/function/debugging",
                    name: "function-debugging",
                    component: FunctionDebugging,
                },
            ],

            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = ["functionsControl"];

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-work-schedules",
            name: "reference-work-schedules",
            component: () => import("../pages/references/work-schedules"),
            meta: {
                title: "Рабочие графики",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.workSchedules);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-dismissal-reasons",
            name: "reference-dismissal-reasons",
            component: () => import("../pages/references/dismissal-reasons"),
            meta: {
                title: "Причины для увольнения",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.dismissalReasons);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-reasons-for-reject-candidate",
            name: "reference-reasons-for-reject-candidate",
            component: () => import("../pages/references/reasons-for-reject-candidate"),
            meta: {
                title: "Причины отказа кандидату",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.reasonsForRejectCandidate);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-worker-candidates-statuses",
            name: "reference-worker-candidates-statuses",
            component: () => import("../pages/references/worker-candidate-statuses"),
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.workerCandidatesStatuses);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-violation-types",
            name: "reference-violation-types",
            component: () => import("../pages/references/violations-types"),
            meta: {
                title: "Типы нарушений",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.foulsTypes);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-reasons-for-fines-and-bonuses",
            name: "reference-reasons-for-fines-and-bonuses",
            component: () => import("../pages/references/reasons-for-fines-and-bonuses"),
            meta: {
                title: "Причины штрафов и премий",
            },
            // beforeEnter: (to, from, next) => {
            // if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
            //     const permissions = Object.values(userPermissionsList.referenceBooks.foulsTypes);
            //
            //     Store.dispatch("getUserPermissions").then(() => {
            //         const userPermissions = Store.state.userPermissions;
            //         const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
            //         if (isAvailablePage) {
            //             next();
            //         } else {
            //             next({ name: "error-403" });
            //         }
            //     });
            // } else {
            //     window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            // }
            // },
        },
        {
            path: "/reference-holiday-surcharges",
            name: "reference-holiday-surcharges",
            component: () => import("../pages/references/holiday-surcharges/holiday-surcharges"),
            meta: {
                title: "Праздничные надбавки",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.holidaySurcharges);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-holiday-surcharges/create",
            name: "reference-holiday-surcharges-create-form",
            component: () => import("../pages/references/holiday-surcharges/holiday-surcharges-form"),
            meta: {
                title: "Новая надбавка",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.holidaySurcharges);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/reference-holiday-surcharges/edit/:id",
            name: "reference-holiday-surcharges-edit-form",
            component: () => import("../pages/references/holiday-surcharges/holiday-surcharges-form"),
            meta: {
                title: "Редактирование надбавки",
            },
            props: true,
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.holidaySurcharges);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/money-source",
            name: "money-source",
            component: () => import("../pages/references/money-source"),
            meta: {
                title: "Источники денежных средств",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.moneySource);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/money-transaction",
            name: "money-transaction",
            component: () => import("../pages/references/money-transaction"),
            meta: {
                title: "Типы проводок",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.moneyTransaction);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/competencies",
            name: "competencies",
            component: () => import("../pages/references/competencies"),
            meta: {
                title: "Компетенции",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.competencies);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/financial-transactions",
            name: "financial-transactions",
            component: () => import("../pages/financial-transactions"),
            meta: {
                title: "Финансовые проводки",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.financialTransaction);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/educational-materials",
            name: "educational-materials",
            component: () => import("../pages/references/educational-materials"),
            meta: {
                title: "Обучающие материалы",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.educationalMaterials);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/calculation-sheets",
            name: "calculation-sheets",
            component: () => import("../pages/calculation-sheets"),
            meta: {
                title: "Расчетные ведомости",
            },
            params: true,
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.calculationSheet);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/calculation-sheets/create",
            name: "calculation-sheets-create",
            component: () => import("../pages/calculation-sheets/create"),
            meta: {
                title: "Новая расчетная ведомость",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.calculationSheet);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/calculation-sheets/:id",
            name: "calculation-sheet",
            component: () => import("../pages/calculation-sheets/calculation-sheet"),
            meta: {
                title: "Расчетная ведомость",
            },
            params: true,
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.calculationSheet);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/couriers-report",
            name: "couriers-report",
            component: () => import("../pages/reports/couriers"),
            meta: {
                title: "Отчёт по курьерам",
            },
        },
        {
            path: "/staff",
            name: "staff",
            component: () => import("../pages/staff/staff-page"),
            children: [
                {
                    path: "candidates",
                    name: "candidates",
                    component: () => import("../pages/staff/candidates/candidates-page"),
                    meta: {
                        title: "Кандидаты",
                    },
                    redirect: {
                        name: "candidates-list",
                    },
                    children: [
                        {
                            path: "list",
                            name: "candidates-list",
                            component: () => import("../pages/staff/candidates/components/candidates-list"),
                            meta: {
                                title: "Кандидаты",
                            },
                        },
                        {
                            path: "reports",
                            name: "candidates-reports",
                            component: () => import("../pages/staff/candidates/components/candidates-reports"),
                            meta: {
                                title: "Отчёты: Кандидаты",
                            },
                        },
                        {
                            path: "period-reports",
                            name: "candidates-period-reports",
                            component: () => import("../pages/staff/candidates/components/candidates-period-reports"),
                            meta: {
                                title: "Отчёты по периоду: Кандидаты",
                            },
                            beforeEnter: (to, from, next) => {
                                window.location.replace("/index.php?r=candidate%2Findex&choose_cand=&CandidateSearch%5Bfull_filters%5D=0&is_export=&options=on&CandidateStatus%5Bchoose_cand%5D=0&CandidateSearch%5Bstatus_id%5D=&CandidateSearch%5Bquest_completion%5D=&CandidateSearch%5Bname_or_phone%5D=&CandidateSearch%5Bpost_code%5D=&CandidateSearch%5Binvited_by_worker_id%5D=-1&CandidateSearch%5Bfilial_id%5D=&CandidateSearch%5Baccountable_id%5D=&CandidateSearch%5Bcitizenship%5D=&active_tab=period_diagram&CandidateSearch%5Bstart%5D=&CandidateSearch%5Bfinish%5D=&CandidateSearch%5Bgroup_period%5D=week");
                            }

                        },
                        {
                            path: "hh-responses",
                            name: "candidates-hh-responses",
                            component: () => import("../pages/staff/candidates/components/candidates-hh-responses"),
                            meta: {
                                title: "Отклики с HH: Кандидаты",
                            },
                            beforeEnter: (to, from, next) => {
                                window.location.replace("/index.php?r=candidate/hh");
                            }
                        },
                    ],
                    beforeEnter: (to, from, next) => {
                        if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                            const permissions = Object.values(userPermissionsList.staff.candidates);

                            Store.dispatch("getUserPermissions").then(() => {
                                const userPermissions = Store.state.userPermissions;
                                const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                                if (isAvailablePage) {
                                    next();
                                } else {
                                    next({ name: "error-403" });
                                }
                            });
                        } else {
                            window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                        }
                    },
                },
                {
                    path: "candidates/:id",
                    name: "candidates-profile",
                    component: () => import("../pages/staff/candidates/components/profile/index.vue"),
                    meta: {
                        title: "Кандидат",
                    },
                    beforeEnter: (to, from, next) => {
                        if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                            const permissions = Object.values(userPermissionsList.staff.candidate);

                            Store.dispatch("getUserPermissions").then(() => {
                                const userPermissions = Store.state.userPermissions;
                                const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                                if (isAvailablePage) {
                                    next();
                                } else {
                                    next({ name: "error-403" });
                                }
                            });
                        } else {
                            window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                        }
                    },
                },
            ],
        },
        {
            path: "/violations",
            name: "violations",
            component: () => import("../pages/violations"),
            meta: {
                title: "Нарушения",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.violations);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/fines-and-bonuses",
            name: "fines-and-bonuses",
            component: () => import("../pages/fines-and-bonuses"),
            meta: {
                title: "Штрафы и премии",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.referenceBooks.finesAndBonuses);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/violations-report",
            name: "violations-report",
            component: () => import("../pages/reports/violations"),
            meta: {
                title: "Сводный отчёт по нарушениям",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.reports.violations);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },
        {
            path: "/fines-and-bonuses-report",
            name: "fines-and-bonuses-report",
            component: () => import("../pages/reports/fines-and-bonuses"),
            meta: {
                title: "Отчёт по штрафам и премиям",
            },
            beforeEnter: (to, from, next) => {
                if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                    const permissions = Object.values(userPermissionsList.reports.finesAndBonuses);

                    Store.dispatch("getUserPermissions").then(() => {
                        const userPermissions = Store.state.userPermissions;
                        const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                        if (isAvailablePage) {
                            next();
                        } else {
                            next({ name: "error-403" });
                        }
                    });
                } else {
                    window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
                }
            },
        },

        ...errorsRoutes,
        ...uikitRoutes,
    ],
});
